import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import farmActions from '../actions/farm'

export const useFarm = () => {
  const data = useSelector((state) => {
    return get(state, 'app.farmManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(farmActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
